import React from "react"
import PropTypes from "prop-types"

class BackgroundModal extends React.Component {

  constructor(props) {
    super(props)

  }

  render() {
    return(
      <div style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        zIndex: 1,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(255,255,255,.5)'
      }} onClick={() => this.props.onClick()}>
          {this.props.children}
      </div>
    )
  }
}

export default BackgroundModal;
